"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReferralFieldAutocomplete = void 0;
const react_1 = require("react");
const OrganizationContext_1 = require("../context/OrganizationContext");
const Constants_1 = require("../utils/Constants");
const useDebouncedAbortableCall_1 = require("./useDebouncedAbortableCall");
const useReferralFieldAutocomplete = (fieldType, currentValue, onChange) => {
    const { selectedOrgUser } = (0, react_1.useContext)(OrganizationContext_1.OrganizationContext);
    const [options, setOptions] = (0, react_1.useState)([]);
    const [showAddMessage, setShowAddMessage] = (0, react_1.useState)(false);
    const changeKey = fieldType === "referralSource" ? "referralSource" : "communityLiaison";
    const selectedOption = currentValue
        ? { label: currentValue, value: currentValue }
        : null;
    const debouncedSearch = (0, useDebouncedAbortableCall_1.useDebouncedAbortableCall)((abortContext, searchText) => __awaiter(void 0, void 0, void 0, function* () {
        if (!searchText || !selectedOrgUser) {
            setOptions([]);
            setShowAddMessage(false);
            return;
        }
        const requestParam = { pageNo: 1, limit: 5, search: searchText };
        const result = fieldType === "referralSource"
            ? yield selectedOrgUser.getReferralSource(requestParam, abortContext)
            : yield selectedOrgUser.getCommunityLiaisoning(requestParam, abortContext);
        if (result.isAborted) {
            return;
        }
        const mapped = result.data.map((item) => ({
            label: item.name,
            value: item.name,
        }));
        setOptions(mapped);
        setShowAddMessage(true);
    }), Constants_1.Constants.API_DEBOUNCE_DELAY_IN_MS, [selectedOrgUser]);
    const onSearch = (searchText) => __awaiter(void 0, void 0, void 0, function* () {
        yield debouncedSearch(searchText);
    });
    const onSelect = (option) => {
        onChange(changeKey, option.label);
    };
    const onAddNew = (name) => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedOrgUser || !name.trim())
            return false;
        const success = fieldType === "referralSource"
            ? yield selectedOrgUser.addReferralSource(name.trim())
            : yield selectedOrgUser.addCommunityLiaisoning(name.trim());
        if (success) {
            onChange(changeKey, name.trim());
        }
        return success;
    });
    return {
        options,
        selectedOption,
        showAddMessage,
        onSearch,
        onSelect,
        onAddNew,
    };
};
exports.useReferralFieldAutocomplete = useReferralFieldAutocomplete;
